import { Flex, Tag } from 'antd'
import React, { ReactNode } from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'
import { Toolbox } from '~/plugins/toolbox/shared'

const Color = Toolbox.Color

const TagWrapper = styled(Tag.CheckableTag)`
  border: 1px solid transparent;

  &.ant-tag-checkable-checked {
    color: black;
    border-color: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};
    background: ${Toolbox.Color.setOpacity(
      DesignSystem.ThemeConst.PRIMARY_YELLOW,
      0.1,
    )};
  }
`

type Option = {
  label: ReactNode
  value: string
}

type Props = {
  id?: string
  value?: string[]
  initialValues?: string[]
  options: Option[]
  onChange?: (values: string[]) => void
}

export const TagWall: React.FC<Props> = ({
  id,
  value: values = [],
  options,
  onChange,
}) => {
  const designSystem = DesignSystem.use()

  const toggleTag = (tag: string) => {
    onChange(
      values.includes(tag)
        ? values.filter(value => value !== tag)
        : [...values, tag],
    )
  }

  return (
    <Flex
      gap={8}
      id={id}
      wrap={!designSystem.isMobile}
      vertical={designSystem.isMobile}
    >
      {options.map(({ label, value }) => (
        <TagWrapper
          key={value}
          checked={values.includes(value)}
          onChange={() => toggleTag(value)}
          style={{
            fontSize: 14,
            padding: '5px 10px',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          {label}
        </TagWrapper>
      ))}
    </Flex>
  )
}
